import { CardWithC4CssProps } from './CssConfig';

export const recruiterPerformanceConfigs = [
  {
    componentReference: 'title',
    label: 'Recruiter performance',
    id: 'recruiter-performance-holder',
    cssProps: {
      width: '100%',
      display: 'block',
    },
    count: 9,
  },

  // row 1 cards
  {
    componentReference: 'container',
    id: 'recruiter-performance-cards-container-row1',
    children: [
      {
        containerType: 'recruiter_performance',
        componentType: 'card',
        componentReference: 'card',
        id: 'sourced_candidates',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'Sourced applications',
          id: 'sourced_candidates',
          value: 142,
          topLabel: 'Sourced applications',
          bottomLabel: 'APPLICANTS',
        },
        api: {
          subject_type: 'recruiter_performance',
          metadata: {
            tileKey: 'sourced_candidates',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'sourced_candidates',
            id: 'sourced_candidates',
          },
        },
      },
      {
        containerType: 'recruiter_performance',
        componentType: 'card',
        componentReference: 'card',
        id: 'screened_candidates',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'Screened applications',
          id: 'screened_candidates',
          value: 98,
          topLabel: 'Screened applications',
          bottomLabel: 'APPLICANTS',
        },
        api: {
          subject_type: 'recruiter_performance',
          metadata: {
            tileKey: 'screened_candidates',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'screened_candidates',
            id: 'screened_candidates',
          },
        },
      },
      {
        containerType: 'recruiter_performance',
        componentType: 'card',
        componentReference: 'card',
        id: 'interviews_scheduled',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'Interviews scheduled',
          id: 'interviews_scheduled',
          value: 64,
          topLabel: 'Interviews scheduled',
          bottomLabel: 'INTERVIEWS',
        },
        api: {
          subject_type: 'recruiter_performance',
          metadata: {
            tileKey: 'interviews_scheduled',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'interviews_scheduled',
            id: 'interviews_scheduled',
          },
        },
      },
      {
        containerType: 'recruiter_performance',
        componentType: 'card',
        componentReference: 'card',
        id: 'offers_sent',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'Offers sent',
          id: 'offers_sent',
          value: 27,
          topLabel: 'Offers sent',
          bottomLabel: 'OFFERS',
        },
        api: {
          subject_type: 'recruiter_performance',
          metadata: {
            tileKey: 'offers_sent',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'offers_sent',
            id: 'offers_sent',
          },
        },
      },
    ],
  },

  // row 2 cards
  {
    componentReference: 'container',
    id: 'recruiter-performance-cards-container-row2',
    children: [
      {
        containerType: 'recruiter_performance',
        componentType: 'card',
        componentReference: 'card',
        id: 'offers_accepted',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'Offer acceptance rate',
          id: 'offers_accepted',
          value: '74%',
          topLabel: 'Offer acceptance rate',
          bottomLabel: 'ACCEPTANCE RATE',
        },
        api: {
          subject_type: 'recruiter_performance',
          metadata: {
            tileKey: 'offers_accepted',
            componentType: 'card',
            apiParam: 'card',
            calculationType: 'rateOfChange',
            unit: 'percent',
            metricKeys: {
              numerator: 'offers_accepted',
              denominator: 'offers_sent',
            },
            id: 'offers_accepted',
          },
        },
      },
      {
        containerType: 'recruiter_performance',
        componentType: 'card',
        componentReference: 'card',
        id: 'hired_candidates',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'Hired',
          id: 'hired_candidates',
          value: 20,
          topLabel: 'Hired',
          bottomLabel: 'APPLICANTS',
        },
        api: {
          subject_type: 'recruiter_performance',
          metadata: {
            tileKey: 'hired_candidates',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'hired_candidates',
            id: 'hired_candidates',
          },
        },
      },
      {
        containerType: 'recruiter_performance',
        componentType: 'card',
        componentReference: 'card',
        id: 'time_to_hire',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'Time to hire',
          id: 'time_to_hire',
          value: '18 Days',
          topLabel: 'Time to hire',
          bottomLabel: 'TIME',
        },
        api: {
          subject_type: 'recruiter_performance',
          metadata: {
            tileKey: 'time_to_hire',
            componentType: 'card',
            apiParam: 'card',
            calculationType: 'avgChange',
            unit: 'time',
            metricKeys: {
              numerator: 'time_to_hire',
              denominator: 'hired_candidates',
            },
            id: 'time_to_hire',
          },
        },
      },
      {
        containerType: 'recruiter_performance',
        componentType: 'card',
        componentReference: 'card',
        id: 'rejected_candidates',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'Rejections',
          id: 'rejected_candidates',
          value: 35,
          topLabel: 'Rejections',
          bottomLabel: 'APPLICANTS',
        },
        api: {
          subject_type: 'recruiter_performance',
          metadata: {
            tileKey: 'rejected_candidates',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'rejected_candidates',
            id: 'rejected_candidates',
          },
        },
      },
    ],
  },

  // table
  {
    containerType: 'recruiter_performance',
    componentType: 'table',
    componentReference: 'table',
    id: 'recruiter_performance_table',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Recruiter performance',
      id: 'recruiter_performance_table',
      tableData: [
        {
          ds: '0',
          dt: 'Alice Johnson',
          header: 'Alice Johnson',
          g1: null,
          g2: null,
          sourced_candidates: 52,
          screened_candidates: 38,
          interviews_scheduled: 24,
          interviews_conducted: 22,
          interviews_rescheduled: 3,
          offers_sent: 10,
          offers_accepted: 8,
          time_to_offer: 1209600,
          offer_revisions_done: 4,
          hired_candidates: 8,
          time_to_hire: 1555200,
          rejected_candidates: 12,
          sourced_candidates_total: 210,
          screened_candidates_total: 145,
          interviews_scheduled_total: 97,
          interviews_conducted_total: 89,
          interview_rescheduled_total: 15,
          offers_sent_total: 40,
          offers_accepted_total: 30,
          time_to_offer_total: 6134400,
          offer_revisions_done_total: 13,
          hired_candidates_total: 30,
          time_to_hire_total: 7862400,
          rejected_candidates_total: 50,
          subRows: [],
        },
        {
          ds: '0',
          dt: 'Bob Smith',
          header: 'Bob Smith',
          g1: null,
          g2: null,
          sourced_candidates: 45,
          screened_candidates: 30,
          interviews_scheduled: 20,
          interviews_conducted: 18,
          interviews_rescheduled: 5,
          offers_sent: 9,
          offers_accepted: 6,
          time_to_offer: 1382400,
          offer_revisions_done: 3,
          hired_candidates: 6,
          time_to_hire: 1728000,
          rejected_candidates: 11,
          sourced_candidates_total: 210,
          screened_candidates_total: 145,
          interviews_scheduled_total: 97,
          interviews_conducted_total: 89,
          interview_rescheduled_total: 15,
          offers_sent_total: 40,
          offers_accepted_total: 30,
          time_to_offer_total: 6134400,
          offer_revisions_done_total: 13,
          hired_candidates_total: 30,
          time_to_hire_total: 7862400,
          rejected_candidates_total: 50,
          subRows: [],
        },
        {
          ds: '0',
          dt: 'Carol Davis',
          header: 'Carol Davis',
          g1: null,
          g2: null,
          sourced_candidates: 45,
          screened_candidates: 30,
          interviews_scheduled: 20,
          interviews_conducted: 19,
          interviews_rescheduled: 2,
          offers_sent: 8,
          offers_accepted: 6,
          time_to_offer: 1036800,
          offer_revisions_done: 2,
          hired_candidates: 6,
          time_to_hire: 1382400,
          rejected_candidates: 12,
          sourced_candidates_total: 210,
          screened_candidates_total: 145,
          interviews_scheduled_total: 97,
          interviews_conducted_total: 89,
          interview_rescheduled_total: 15,
          offers_sent_total: 40,
          offers_accepted_total: 30,
          time_to_offer_total: 6134400,
          offer_revisions_done_total: 13,
          hired_candidates_total: 30,
          time_to_hire_total: 7862400,
          rejected_candidates_total: 50,
          subRows: [],
        },
        {
          ds: '0',
          dt: 'Dan Patel',
          header: 'Dan Patel',
          g1: null,
          g2: null,
          sourced_candidates: 38,
          screened_candidates: 25,
          interviews_scheduled: 18,
          interviews_conducted: 16,
          interviews_rescheduled: 4,
          offers_sent: 7,
          offers_accepted: 5,
          time_to_offer: 1555200,
          offer_revisions_done: 3,
          hired_candidates: 5,
          time_to_hire: 1900800,
          rejected_candidates: 8,
          sourced_candidates_total: 210,
          screened_candidates_total: 145,
          interviews_scheduled_total: 97,
          interviews_conducted_total: 89,
          interview_rescheduled_total: 15,
          offers_sent_total: 40,
          offers_accepted_total: 30,
          time_to_offer_total: 6134400,
          offer_revisions_done_total: 13,
          hired_candidates_total: 30,
          time_to_hire_total: 7862400,
          rejected_candidates_total: 50,
          subRows: [],
        },
        {
          ds: '0',
          dt: 'Eva Chen',
          header: 'Eva Chen',
          g1: null,
          g2: null,
          sourced_candidates: 30,
          screened_candidates: 22,
          interviews_scheduled: 15,
          interviews_conducted: 14,
          interviews_rescheduled: 1,
          offers_sent: 6,
          offers_accepted: 5,
          time_to_offer: 950400,
          offer_revisions_done: 1,
          hired_candidates: 5,
          time_to_hire: 1296000,
          rejected_candidates: 7,
          sourced_candidates_total: 210,
          screened_candidates_total: 145,
          interviews_scheduled_total: 97,
          interviews_conducted_total: 89,
          interview_rescheduled_total: 15,
          offers_sent_total: 40,
          offers_accepted_total: 30,
          time_to_offer_total: 6134400,
          offer_revisions_done_total: 13,
          hired_candidates_total: 30,
          time_to_hire_total: 7862400,
          rejected_candidates_total: 50,
          subRows: [],
        },
      ],
    },
    api: {
      subject_type: 'recruiter_performance',
      metadata: {
        tileKey: 'recruiter_performance_table',
        componentType: 'table',
        apiParam: 'chart_table',
        filters: {
          group_by_1: {
            id: 'action_performed_by_user',
            key: 'user',
            label: 'User',
          },
          group_by_2: { id: null, label: 'None' },
        },
        headerKeys: [
          'sourced_candidates',
          'screened_candidates',
          'interviews_scheduled',
          'interviews_conducted',
          'interviews_rescheduled',
          'offers_sent',
          'offers_accepted',
          'time_to_offer',
          'offer_revisions_done',
          'hired_candidates',
          'time_to_hire',
          'rejected_candidates',
        ],
        id: 'recruiter_performance_table',
      },
    },
  },
];
